(() => {
  if (!('IntersectionObserver' in window)) return;
  const targets = '.sf-card,.sf-media-shell,.ss-tile,.ss-scene,.sf-press,.sf-trio-progress,.sf-progress-compact,.sf-collection-directory>article';
  const observed = new WeakSet();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => entry.target.classList.toggle('sf-perf-offscreen', !entry.isIntersecting));
  }, { rootMargin: '200px' });
  function visit(root, callback) {
    if (root.matches?.(targets)) callback(root);
    root.querySelectorAll?.(targets).forEach(callback);
  }
  function scan(root) {
    visit(root, element => {
      if (!element.isConnected || observed.has(element)) return;
      observed.add(element);
      observer.observe(element);
    });
  }
  function remove(root) {
    visit(root, element => {
      if (element.isConnected) return;
      observer.unobserve(element);
      observed.delete(element);
    });
  }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    visit(event.target, element => { observer.unobserve(element); observed.delete(element); });
  });
  const mutations = new MutationObserver(records => {
    records.forEach(record => {
      record.removedNodes.forEach(node => { if (node.nodeType === 1) remove(node); });
      record.addedNodes.forEach(node => { if (node.nodeType === 1) scan(node); });
    });
  });
  mutations.observe(document.body, { childList: true, subtree: true });
  const visibility = () => document.documentElement.classList.toggle('sf-perf-background', document.hidden);
  document.addEventListener('visibilitychange', visibility);
  visibility();
})();
